const toggleModal = (element, toggle) => {
  const parentElement = element.closest('[data-modal-parent]');
  const parentId = element.closest('[data-id]')?.getAttribute('data-id');
  const modal = parentElement?.querySelector(`[data-modal]${parentId ? `[data-id="${parentId}"]` : ''}`);
  modal?.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

attachEvent('[data-detail-modal-trigger]', 'click', (ev) => {
  ev.preventDefault();
  toggleModal(ev.target, true);
});

// Close modal
attachEvent('[data-close-modal]', 'click', (ev) => {
  ev.preventDefault();
  toggleModal(ev.target, false);
});

// Close modal on Escape key
onKeydown('escape', () => {
  document.querySelectorAll('[data-modal].is-open-modal').forEach((ev) => {
    toggleModal(ev, false);
  });
});
